import { PAGINATION } from '../constants';
import { getState, setState } from '../analytics-state';

export const pagination = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('@@HDHOME/PLP_PAGINATION_CLICK', (payload) => {
    if (window.isDebugMode) {
      console.log('%c @@HDHOME/PLP_PAGINATION_CLICK is deprecated.', 'background: red; color: black', payload);
    }
  });

  window.LIFE_CYCLE_EVENT_BUS.on('pagination.click', function () {
    setState({
      ...getState(),
      pageTransitionEvent: PAGINATION
    });
  });
};
